<template>
   <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
export default {
  name: "pictorialBar",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "80px"
    },

    // unit: {
    //   type: String,
    //   default: ""
    // },
    chartData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    // if (this.chartData) {
      this.initChart();
    // }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData() {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.initChart();
    }
  },
  methods: {
    /*initChart() {
        var maxData = 100;
        var option = {
            backgroundColor:'#072B68',
            tooltip: {},
            xAxis: {
                max: maxData,
                splitLine: {
                    show: false
                },
                offset: 20,
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                axisLabel: {
                    show: false
                }
            },
            yAxis: {
                data: ['五公交'],
                inverse: true,
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                axisLabel: {
                    margin: 100,
                    textStyle: {
                        color: '#fff',
                        fontSize: 14
                    },
                    align:'left'
                }
            },
            grid: {
                top: 'center',
                height: 200,
                left: 180,
                right: 130
            },
            series: [{ // 外边框
                name: '',
                type: 'pictorialBar',
                symbol: 'rect',
                //barWidth: '10%',
                symbolOffset: ['-1.1%', 0], //位置
                symbolSize: ['102%', 18],
                itemStyle: {
                    normal: {
                        color: 'rgba(27,77,140,1)'
                    }
                },
                z: -180, //图层
                symbolRepeat: null,
                symbolBoundingData: maxData,
                data: [98.58, 98.64, 98.70, 99.03,99.34],
                animationEasing: 'elasticOut',

            },
                { // 内边框
                    name: '',
                    type: 'pictorialBar',
                    symbol: 'reat',
                    //barWidth: '9%',
                    //barMaxWidth: '20%',
                    symbolOffset: ['-0.5%', 0],
                    symbolSize: ['101%', 15],
                    itemStyle: {
                        normal: {

                            color: 'rgba(0,0,0,.5)'
                        }
                    },
                    z: -20,
                    symbolRepeat: null,
                    symbolBoundingData: maxData,
                    data: [98.58],
                    animationEasing: 'elasticOut',

                },


                {
                    // current data
                    type: 'pictorialBar',
                    symbol: 'rect',
                    itemStyle: {
                        normal: {
                            barBorderRadius: 5,
                            color: '#74EEFF',

                        }
                    },
                    symbolRepeat: 'fixed',
                    symbolMargin: '5%',
                    symbolClip: true,
                    symbolSize: [18,13],
                    symbolBoundingData: maxData,
                    data: [98.58],
                    z: 99999999,
                    animationEasing: 'elasticOut',
                    animationDelay: function(dataIndex, params) {
                        return params.index * 30;
                    }
                }
            ]
        };
        this.chart = this.$echarts.init(document.getElementById(this.id));
        this.chart.setOption(option);
    }*/
      initChart() {
          var maxData = 100;

          var option = {
              // backgroundColor:'#072B68',
              tooltip: {},
              xAxis: {
                  max: maxData,
                  splitLine: {
                      show: false
                  },
                  offset: 20,
                  axisTick: {
                      show: false
                  },
                  axisLine: {
                      show: false
                  },
                  axisLabel: {
                      show: false
                  }
              },
              yAxis: {
                  data: ['总体好评率'],
                  inverse: true,
                  axisTick: {
                      show: false
                  },
                  axisLine: {
                      show: false
                  },
                  axisLabel: {
                      margin: 100,
                      textStyle: {
                          color: '#fff',
                          fontSize: 14
                      },
                      align:'left'
                  }
              },
              grid: {
                  top: 'center',
                  // height: 200,
                  left: 110,
                  right: 90
              },
              series: [{ // 外边框
                  name: '',
                  type: 'pictorialBar',
                  symbol: 'rect',
                  //barWidth: '10%',
                  symbolOffset: ['-1.1%', 0], //位置
                  symbolSize: ['102%', 18],
                  itemStyle: {
                      normal: {
                          color: 'rgba(27,77,140,1)'
                      }
                  },
                  z: -180, //图层
                  symbolRepeat: null,
                  symbolBoundingData: maxData,
                  data: [98.58, 98.64, 98.70, 99.03,99.34],
                  animationEasing: 'elasticOut',

              },
                  { // 内边框
                      name: '',
                      type: 'pictorialBar',
                      symbol: 'reat',
                      //barWidth: '9%',
                      //barMaxWidth: '20%',
                      symbolOffset: ['-0.5%', 0],
                      symbolSize: ['101%', 15],
                      itemStyle: {
                          normal: {

                              color: 'rgba(0,0,0,.5)'
                          }
                      },
                      z: -20,
                      symbolRepeat: null,
                      symbolBoundingData: maxData,
                      data: [98.58],
                      animationEasing: 'elasticOut',

                  },


                  {
                      // current data
                      type: 'pictorialBar',
                      symbol: 'rect',
                      itemStyle: {
                          normal: {
                              barBorderRadius: 5,
                              color: '#74EEFF',

                          }
                      },
                      symbolRepeat: 'fixed',
                      symbolMargin: '5%',
                      symbolClip: true,
                      symbolSize: [18,13],
                      symbolBoundingData: maxData,
                      data: [98.58],
                      z: 99999999,
                      animationEasing: 'elasticOut',
                      animationDelay: function(dataIndex, params) {
                          return params.index * 30;
                      }
                  }, {
                      // full data
                      type: 'pictorialBar',
                      itemStyle: {
                          normal: {
                              color: 'rgba(17,57,132,.7)'
                          }
                      },
                      label: {
                          normal: {
                              show: true,
                              formatter: function(params) {
                                  return (params.value+'%');
                              },
                              position: 'right',
                              offset: [30, 0],
                              textStyle: {
                                  color: '#6EE1F7',
                                  fontSize: 14
                              }
                          }
                      },
                      animationDuration: 0,
                      symbolRepeat: 'fixed',
                      symbolMargin: '5%',
                      symbol: 'rect',
                      symbolSize: [18,13],
                      symbolBoundingData: maxData,
                      data: [98.58],
                      z: 99999,
                      animationEasing: 'elasticOut',
                      animationDelay: function(dataIndex, params) {
                          return params.index * 30;
                      }
                  }
              ]
          };
          this.chart = this.$echarts.init(document.getElementById(this.id));
          this.chart.setOption(option);
      }
  }
};
</script>
<style scoped lang="less">
.chart {
  width: 100% !important;
  height: 100% !important;
}
</style>
